<template>

  <div
    class="main-menu menu-fixed menu-accordion menu-shadow"
    :class="[
      {
        expanded:
          !isVerticalMenuCollapsed ||
          (isVerticalMenuCollapsed && isMouseHovered),
      },
      skin === 'semi-dark' ? 'menu-dark' : 'menu-light',
    ]"
  >
  <!-- Toggler Button -->
         
    <!-- @mouseenter="updateMouseHovered(true)"
    @mouseleave="updateMouseHovered(false)" -->
    <!-- main menu header-->
    <div class="navbar-header expanded" :class="{'navbar-header-collapsed': isVerticalMenuCollapsed}">
      <slot
        name="header"
        :toggleVerticalMenuActive="toggleVerticalMenuActive"
        :toggleCollapsed="toggleCollapsed"
        :collapseTogglerIcon="collapseTogglerIcon"
      >
        <ul class="nav navbar-nav" :class="{'flex-row': !isVerticalMenuCollapsed}">
          <!-- Logo & Text -->
          <li class="nav-item mr-auto">
            <b-link class="navbar-brand" to="/">
              <span class="brand-logo">
                <b-img
                  :src="getLogoPath"
                  alt="logo"
                  :class="{
                    'logo-collapsed':
                      isVerticalMenuCollapsed && !isMouseHovered,
                  }"
                />
              </span>
              <!--  <h2 class="brand-text">
                {{ appName }}
              </h2> -->
            </b-link>
          </li>
         
         

         <!--   <li class="nav-item mr-auto cursor-pointer" style="margin-top: 30px;margin-left: 5px;" v-if="isVerticalMenuCollapsed">
            <feather-icon
                :icon="collapseTogglerIconFeather"
                size="20"
                class="d-none d-xl-block collapse-toggle-icon"
                @click="toggleCollapsed"
              />
          </li> -->
        </ul>
         
        <ul class="nav navbar-nav flex-row">
          <!-- <user-dropdown/> -->
          <!-- <li class="nav-item mr-auto">
            <b-link class="navbar-brand" to="/">
              <span class="brand-logo">
                <b-img :src="appLogoImage" alt="logo" />
              </span>
              <h2 class="brand-text">
                {{ appName }}
              </h2>
            </b-link>
          </li>
          <li class="nav-item nav-toggle">
            <b-link class="nav-link modern-nav-toggle">
              <feather-icon
                icon="XIcon"
                size="20"
                class="d-block d-xl-none"
                @click="toggleVerticalMenuActive"
              />
              <feather-icon
                :icon="collapseTogglerIconFeather"
                size="20"
                class="d-none d-xl-block collapse-toggle-icon"
                @click="toggleCollapsed"
              />
            </b-link>
          </li> -->
        </ul>
      </slot>
    </div>
    <!-- / main menu header-->

    <!-- Shadow -->
    <div :class="{ 'd-block': shallShadowBottom }" class="shadow-bottom" />

    <!-- main menu content-->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="main-menu-content scroll-area"
      tagname="ul"
      @ps-scroll-y="
        (evt) => {
          shallShadowBottom = evt.srcElement.scrollTop > 0;
        }
      "
    >
      <vertical-nav-menu-custom></vertical-nav-menu-custom>

      <vertical-nav-menu-items
        v-if="currentNavMenuItens.length > 0"
        :items="currentNavMenuItens"
        class="navigation navigation-main"
      />
    </vue-perfect-scrollbar>
    <!-- /main menu content-->

    <!-- main menu footer-->
    <vertical-nav-footer 
      @open-help="openHelp"
      @open-attendance="openAttendance"
    >
    </vertical-nav-footer>
    <!-- /main menu footer-->

    <!-- Help Modal -->
    <b-modal
      modal-class="modal-primary custom-help-modal"
      ref="help-modal"
      :title="$t('HELP_MODAL.Title')"
      hide-footer
      size="lg"
      centered
    >
      <div class="d-block">
        <app-help></app-help>
      </div>
    </b-modal>
    <!-- /Help Modal -->

    <!-- Attendance Modal -->
    <b-modal
      modal-class="modal-primary custom-attendance-modal"
      ref="attendance-modal"
      size="lg"
      centered
    >
      <div class="d-block">
        <app-attendance></app-attendance>
      </div>
    </b-modal>
    <!-- /Attendance Modal -->
  </div>
</template>

<script>
import navMenuItems from "@/navigation/vertical";
import navMenuItemsAdmin from "@/navigation/vertical/admin";
import navMenuItemsContract from "@/navigation/vertical/admin-contract";
import navMenuItemsAttendance from "@/navigation/vertical/admin-attendance";
import navMenuItemsMarketing from "@/navigation/vertical/admin-marketing";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { BLink, BImg } from "bootstrap-vue";
import { provide, computed, ref } from "@vue/composition-api";
import useAppConfig from "@core/app-config/useAppConfig";
import { $themeConfig } from "@themeConfig";
import VerticalNavMenuItems from "./components/vertical-nav-menu-items/VerticalNavMenuItems.vue";
import VerticalNavMenuCustom from "./components/vertical-nav-menu-custom/VerticalNavMenuCustom.vue";
import VerticalNavFooter from "./vertical-nav-footer/VerticalNavFooter.vue";
import useVerticalNavMenu from "./useVerticalNavMenu";
// import UserDropdown from '../../../../../layouts/components/UserDropdown.vue';
import AppHelp from "../../../components/app-help/AppHelp.vue";
import AppConstants from '@/appConstants';
import AppAttendance from "@/@core/layouts/components/app-attendance/AppAttendance.vue";

export default {
  components: {
    VuePerfectScrollbar,
    VerticalNavMenuItems,
    VerticalNavMenuCustom,
    VerticalNavFooter,
    BLink,
    BImg,
    // UserDropdown,
    AppHelp,
    AppAttendance
  },
  props: {
    isVerticalMenuActive: {
      type: Boolean,
      required: true,
    },
    toggleVerticalMenuActive: {
      type: Function,
      required: true,
    },
  },
  created() {
    this.checkAdminMenu();
  },
  computed: {
    displayFilter() {
      return this.$store.state.manageNews.displayFilter;
    },
    userData() {
      return this.$store.state.auth.currentUser || {};
    },
    getLogoPath() {
      if (this.isVerticalMenuCollapsed && !this.isMouseHovered) {
        if (this.userData.theme == AppConstants.THEME_DARK) {
          return this.appLogoImageCollapsedBlack;
        } 
        return this.appLogoImageCollapsedWhite;
      } 

      if (this.userData.theme == AppConstants.THEME_DARK) {
          return this.appLogoImageBlack;
        } 
      return this.appLogoImageWhite;
    },
  },
  watch: {
    "userData.profile"() {
      this.checkAdminMenu();
    },
  },
  methods: {
    checkAdminMenu() {
      if (this.$store.state.auth.isAuthenticated) {
        this.currentNavMenuItens = [];
        if (this.userData.profile == AppConstants.USER_PROFILE.ADMIN) {
          this.currentNavMenuItens = navMenuItems.concat(navMenuItemsAdmin);
        } else if (this.userData.profile == AppConstants.USER_PROFILE.ATTENDANCE) {
          this.currentNavMenuItens = navMenuItems.concat(navMenuItemsAttendance);
        } else if (this.userData.profile == AppConstants.USER_PROFILE.CONTRACT) {
          this.currentNavMenuItens = navMenuItems.concat(navMenuItemsContract);
        } else if (this.userData.profile == AppConstants.USER_PROFILE.MARKETING) {
          this.currentNavMenuItens = navMenuItems.concat(navMenuItemsMarketing);
        } else {
          this.currentNavMenuItens = navMenuItems;
        }
        this.$forceUpdate();
      }
    },
    openHelp() {
      // console.log('openhelp')
      this.$refs["help-modal"].show();
    },
    openAttendance() {
      // console.log('openhelp')
      this.$refs["attendance-modal"].show();
    },
  },
  setup(props) {
    const {
      isMouseHovered,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      updateMouseHovered,
    } = useVerticalNavMenu(props);

    const currentNavMenuItens = ref([]);

    const { skin } = useAppConfig();

    // Shadow bottom is UI specific and can be removed by user => It's not in `useVerticalNavMenu`
    const shallShadowBottom = ref(false);

    provide("isMouseHovered", isMouseHovered);

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    };

    const collapseTogglerIconFeather = computed(() =>
      collapseTogglerIcon.value === "unpinned" ? "ArrowRightCircleIcon" : "ArrowLeftCircleIcon"
    );

    // App Name
    const { appName, appLogoImageWhite, appLogoImageCollapsedWhite, appLogoImageBlack, appLogoImageCollapsedBlack } = $themeConfig.app;

    return {
      navMenuItems,
      navMenuItemsAdmin,
      perfectScrollbarSettings,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      isMouseHovered,
      updateMouseHovered,
      collapseTogglerIconFeather,

      // Shadow Bottom
      shallShadowBottom,

      // Skin
      skin,

      // App Name
      appName,
      appLogoImageWhite, 
      appLogoImageCollapsedWhite, 
      appLogoImageBlack, 
      appLogoImageCollapsedBlack,
      currentNavMenuItens,
    };
  },
};
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/vertical-menu.scss";
</style>
